import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ArtForBusinessService {
  private BASE = `${environment.apiUrl}/api/unauth`;

  constructor(private http: HttpClient) {}

  add(data: any): Observable<any> {
    return this.http.post(`${this.BASE}/art_for_business`, data);
  }
}
